import {
  ACCESSAPI_FAILD,
  ACCESSAPI_LOADING,
  ACCESSAPI_SUCCESS,
  ACCESSAPI_REMOVE,
  MERCHANT_SECRET_LOADING,
  MERCHANT_SECRET_SUCCESS,
  MERCHANT_SECRET_FAILD,
} from "../types";

const initialState = {
  loading: false,
  error: null as string | null,
  status: null as number | null,
  responseData: null as any,
};

export const accessApiwReducer = (
  state = initialState,
  action: {
    type: string;
    loading?: boolean;
    payload?: any;
    status?: number;
    error?: any;
  }
) => {
  switch (action.type) {
    case ACCESSAPI_LOADING:
      return {
        ...state,
        loading: action.loading ?? false,
      };

    case ACCESSAPI_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.status ?? null,
        error: null,
        responseData: action.payload ?? null,
      };

    case ACCESSAPI_FAILD:
      return {
        ...state,
        loading: false,
        status: action.status ?? null,
        error:
          action.payload?.message ||
          action.error ||
          "Something error !! Please contact the technical administrator.",
        responseData: null,
      };

    case ACCESSAPI_REMOVE:
      return initialState;

    default:
      return state;
  }
};

// Merchant Secret Reducer
const merchantSecretInitialState = {
  loading: false,
  error: null as string | null,
  status: null as number | null,
  secret: null as string | null,
};

export const merchantSecretReducer = (
  state = merchantSecretInitialState,
  action: {
    type: string;
    loading?: boolean;
    payload?: any;
    status?: number;
    error?: any;
  }
) => {
  switch (action.type) {
    case MERCHANT_SECRET_LOADING:
      return {
        ...state,
        loading: action.loading ?? false,
      };

    case MERCHANT_SECRET_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.status ?? null,
        error: null,
        secret: action.payload?.secret || action.payload || null,
      };

    case MERCHANT_SECRET_FAILD:
      return {
        ...state,
        loading: false,
        status: action.status ?? null,
        error:
          action.payload?.message ||
          action.error ||
          "Something error !! Please contact the technical administrator.",
        secret: null,
      };

    default:
      return state;
  }
};
